import { ProductFilter } from './product-filter';
import { ProductFilters } from './product-filters';

export class ClaimLimit implements ProductFilter {
  masks: string[];
  selected: boolean = false;
  display: boolean = true;
  property: keyof ProductFilters = 'claimLimit';

  constructor(
    public label: '5K' | '15K' | '30K', public key = label
  ) {
    switch (key) {
      case '5K':
        this.masks = ['5000', '5K'];
        break;
      case '15K':
        this.masks = ['15000', '15K'];
        break;
      case '30K':
        this.masks = ['30000', '30K'];
        break;
    }
  }
}
